import React, { ReactNode, useState, useCallback } from 'react'
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine'

export interface FilterExpandableProps {
  children: ReactNode
  label?: string
  defaultExpanded?: boolean
}

/** Раскрывающийся блок дополнительных фильтров */
export default function FilterExpandable ({
  children,
  label = 'Дополнительные фильтры',
  defaultExpanded = false
}: FilterExpandableProps) {
  const [ expanded, setExpanded ] = useState(defaultExpanded)

  const toggleExpanded = useCallback(() => {
    setExpanded(prev => !prev)
  }, [])

  return (
    <div className="FilterExpandable">
      <button
        type="button"
        className={`FilterExpandable__Toggle ${expanded ? 'FilterExpandable__Toggle--expanded' : ''}`}
        onClick={toggleExpanded}
      >
        <ArrowDownLineIcon />
        {expanded ? 'Скрыть фильтры' : label}
      </button>
      <div className={`FilterExpandable__Content ${expanded ? 'FilterExpandable__Content--visible' : ''}`}>
        {children}
      </div>
    </div>
  )
}
